import { render, staticRenderFns } from "./Criar-Comunicado.vue?vue&type=template&id=603cbd10&"
import script from "./Criar-Comunicado.vue?vue&type=script&lang=js&"
export * from "./Criar-Comunicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Comunicado.vue"
export default component.exports